// extracted by mini-css-extract-plugin
export var actionText = "_le-4";
export var container = "_le-0";
export var leftSection = "_le-1";
export var rightSection = "_le-2";
export var settingsButton = "_le-6";
export var settingsIcon = "_le-7";
export var shortcut = "_le-5";
export var shortcutGroup = "_le-3";